import React, { Component } from 'react';
import { Typography } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { showNumber } from '../statusConfig';
import { amountToString } from '../../../util/tool';
import './renderlist.less';

export default class RenderList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleConfig: [
        {
          "name": "商品",
          "rolWidth": 1
        },
        {
          "name": "单价",
          "rolWidth": 1
        },
        {
          "name": "税率",
          "rolWidth": 1
        },
        {
          "name": "含税单价",
          "rolWidth": 1
        },
        {
          "name": "数量",
          "rolWidth": 1
        },
        {
          "name": "小计",
          "rolWidth": 1
        },
        {
          "name": "订单状态",
          "rolWidth": 1
        },
        // {
        //   "name": "交易操作",
        //   "rolWidth": 1
        // }
      ]
    };
  }

  renderDetail = () => {
    // const parseInfo = JSON.parse((info));
    // const surcharge_desc = !info ? [] : parseInfo;
    // const record = { qoute: { surcharge_desc } };
    // return <RenderPopover record={record} />;
  }

  render() {
    const { titleConfig = [] } = this.state;
    const { formateList = [], toOrderDetail, expandFn, toProductDetail } = this.props;
    return (
      <div className='render-list-container render-list-container-enquiry'>
        <div className='render-list-title'>{titleConfig.map((item, index) => <div className={index < titleConfig.length - 1 ? (index > 0 ? 'render-list-title-item-normal1' : 'render-list-title-item') : 'render-list-title-item-normal4'} key={index}>{item.name}</div>)}</div>
        <div className='render-list-content'>
          {
            formateList.map(item => {
              return (
                <div className='render-list-content-container' key={item.order_no}>
                  <div className='render-list-content-title'>
                    <div>订单号：{item.order_no}</div>
                    <div>下单时间：{item.create_time}</div>
                    <div>期望到货日期：{item.expected_date}</div>
                  </div>
                  <div className='render-list-content-products-container'>
                    <div className='render-list-content-products-container-left'>
                      {item.products.slice(0, item.isExpand ? showNumber : item.products.length).map((subItem, subIndex) => (
                        <div className='render-list-content-products-item' key={subIndex}>
                          <div className='render-list-content-detail'>
                            <div className='render-list-content-detail-product render-list-content-detail-product-enquiry '>
                              {/* <div className='render-list-content-detail-product-left'><img src={subItem.product_img} alt="" /></div> */}
                              <div className='render-list-content-detail-product-right'>
                                <div className='pointer render-list-content-detail-product-right-title' onClick={() => toProductDetail(subItem)}>{subItem.sku_name}</div>
                                <div>规格：{subItem.sale_norms}</div>
                              </div>
                            </div>
                            <div className='render-list-content-detail-item'>{subItem.purchase_order_no ? <>¥ {`${amountToString(subItem.sale_price)}`}</> : ' '}</div>
                            <div className='render-list-content-detail-item'>{subItem.purchase_order_no ? <>{subItem.tax_rate >= 0 ? (+subItem.tax_rate + '%') : '-'}</> : ''}</div>
                            <div className='render-list-content-detail-item'>{subItem.purchase_order_no ? <>¥ {`${amountToString(subItem.tax_sale_price)}`}</> : ' '}</div>
                            <div className='render-list-content-detail-item'>X{(+subItem.sale_number)}</div>
                            <div className='render-list-content-detail-item'>{subItem.purchase_order_no ? <>¥ {`${amountToString(subItem.tax_sale_price_total)}`}</> : ' '}</div>
                          </div>
                        </div>
                      ))}

                      {item.products.length > showNumber ?
                        <div className='render-list-content-expand pointer' onClick={() => expandFn(item)}>
                          {item.isExpand ? <span><span>共<Typography.Link>{item.products.length}</Typography.Link>种商品，查看全部</span><DownOutlined /></span> : <span><span>收起</span><UpOutlined /></span>}
                        </div> : null}
                    </div>
                    <div className='render-list-content-products-container-right render-list-content-products-container-right-enquiry'>
                      {/* <div className='render-list-content-products-container-right-item'>
                        {subItem.purchase_order_no ? <>¥ {`${subItem.tax_sale_price} / ${subItem.sale_unit}`}</> : ' '}
                      </div> */}
                      <div className='render-list-content-products-container-right-item'>
                        {/* <div><Typography.Link>{item.statusText}</Typography.Link></div> */}
                        {/* {item.quote.length ? <div><Typography.Link> 有{item.quote.length}家公司报价</Typography.Link></div> : ''} */}
                        {+item.order_status === 20 ? '已采购' : <Typography.Link> 有{item.quote.length}家公司报价</Typography.Link>}
                        <div className='pointer' onClick={() => { toOrderDetail(item); }}>订单详情</div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}
